var cov_pj8e38iik = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/Card.tsx",
      hash = "c1710f49d1cd48a2c36642969925ee7074710014",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/Card.tsx",
    statementMap: {
      "0": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 16
        }
      },
      "1": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 34,
          column: 5
        }
      },
      "2": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 50
        }
      },
      "3": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 52
        }
      },
      "4": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 56
        }
      },
      "5": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 54
        }
      },
      "6": {
        start: {
          line: 43,
          column: 39
        },
        end: {
          line: 43,
          column: 49
        }
      },
      "7": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 38
        }
      },
      "8": {
        start: {
          line: 44,
          column: 22
        },
        end: {
          line: 44,
          column: 38
        }
      },
      "9": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 69
        }
      },
      "10": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 51,
          column: 5
        }
      },
      "11": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 43
        }
      },
      "12": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 21
        }
      },
      "13": {
        start: {
          line: 56,
          column: 29
        },
        end: {
          line: 56,
          column: 39
        }
      },
      "14": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 38
        }
      },
      "15": {
        start: {
          line: 57,
          column: 22
        },
        end: {
          line: 57,
          column: 38
        }
      },
      "16": {
        start: {
          line: 61,
          column: 22
        },
        end: {
          line: 61,
          column: 42
        }
      },
      "17": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 63,
          column: 37
        }
      },
      "18": {
        start: {
          line: 62,
          column: 31
        },
        end: {
          line: 62,
          column: 63
        }
      },
      "19": {
        start: {
          line: 63,
          column: 9
        },
        end: {
          line: 63,
          column: 37
        }
      },
      "20": {
        start: {
          line: 67,
          column: 17
        },
        end: {
          line: 67,
          column: 51
        }
      },
      "21": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 69,
          column: 51
        }
      },
      "22": {
        start: {
          line: 68,
          column: 14
        },
        end: {
          line: 68,
          column: 51
        }
      },
      "23": {
        start: {
          line: 69,
          column: 9
        },
        end: {
          line: 69,
          column: 51
        }
      },
      "24": {
        start: {
          line: 73,
          column: 28
        },
        end: {
          line: 73,
          column: 38
        }
      },
      "25": {
        start: {
          line: 74,
          column: 22
        },
        end: {
          line: 74,
          column: 41
        }
      },
      "26": {
        start: {
          line: 75,
          column: 19
        },
        end: {
          line: 75,
          column: 76
        }
      },
      "27": {
        start: {
          line: 76,
          column: 22
        },
        end: {
          line: 79,
          column: 5
        }
      },
      "28": {
        start: {
          line: 81,
          column: 47
        },
        end: {
          line: 88,
          column: 5
        }
      },
      "29": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 94,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 32
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 17
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 42
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        loc: {
          start: {
            line: 48,
            column: 32
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 48
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 54,
            column: 2
          },
          end: {
            line: 54,
            column: 3
          }
        },
        loc: {
          start: {
            line: 54,
            column: 34
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 54
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        },
        loc: {
          start: {
            line: 60,
            column: 19
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 60
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 28
          },
          end: {
            line: 70,
            column: 3
          }
        },
        line: 66
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 72,
            column: 3
          }
        },
        loc: {
          start: {
            line: 72,
            column: 11
          },
          end: {
            line: 95,
            column: 3
          }
        },
        line: 72
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 38
          }
        }, {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 38
          }
        }],
        line: 44
      },
      "1": {
        loc: {
          start: {
            line: 45,
            column: 11
          },
          end: {
            line: 45,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 45,
            column: 37
          },
          end: {
            line: 45,
            column: 46
          }
        }, {
          start: {
            line: 45,
            column: 49
          },
          end: {
            line: 45,
            column: 69
          }
        }],
        line: 45
      },
      "2": {
        loc: {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        }, {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        }],
        line: 49
      },
      "3": {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 38
          }
        }, {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 38
          }
        }],
        line: 57
      },
      "4": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 63,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 63,
            column: 37
          }
        }, {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 63,
            column: 37
          }
        }],
        line: 62
      },
      "5": {
        loc: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 69,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 69,
            column: 51
          }
        }, {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 69,
            column: 51
          }
        }],
        line: 68
      },
      "6": {
        loc: {
          start: {
            line: 75,
            column: 19
          },
          end: {
            line: 75,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 75,
            column: 48
          },
          end: {
            line: 75,
            column: 56
          }
        }, {
          start: {
            line: 75,
            column: 59
          },
          end: {
            line: 75,
            column: 76
          }
        }],
        line: 75
      },
      "7": {
        loc: {
          start: {
            line: 77,
            column: 29
          },
          end: {
            line: 77,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 29
          },
          end: {
            line: 77,
            column: 40
          }
        }, {
          start: {
            line: 77,
            column: 44
          },
          end: {
            line: 77,
            column: 57
          }
        }],
        line: 77
      },
      "8": {
        loc: {
          start: {
            line: 77,
            column: 59
          },
          end: {
            line: 77,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 59
          },
          end: {
            line: 77,
            column: 68
          }
        }, {
          start: {
            line: 77,
            column: 72
          },
          end: {
            line: 77,
            column: 83
          }
        }],
        line: 77
      },
      "9": {
        loc: {
          start: {
            line: 77,
            column: 85
          },
          end: {
            line: 77,
            column: 101
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 85
          },
          end: {
            line: 77,
            column: 92
          }
        }, {
          start: {
            line: 77,
            column: 96
          },
          end: {
            line: 77,
            column: 101
          }
        }],
        line: 77
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/Card.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { defaultProps } from '../utils/defaultProps';
import { dispatchEvent } from '../utils/dom/element';
import { cardClass } from './styles';
import { Provider } from './context';
import { compose } from '../utils/func';
import resizable from '../hoc/resizable';
import moveable from '../hoc/moveable';
import { modalClass } from '../Modal/styles';
import { isRTL } from '../config';

var Card =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Card, _PureComponent);

  var _super = _createSuper2(Card);

  function Card(props) {
    var _this;

    _classCallCheck(this, Card);

    cov_pj8e38iik.f[0]++;
    cov_pj8e38iik.s[0]++;
    _this = _super.call(this, props);
    _this.element = void 0;
    cov_pj8e38iik.s[1]++;
    _this.state = {
      collapsed: props.defaultCollapsed,
      formStatus: ''
    };
    cov_pj8e38iik.s[2]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_pj8e38iik.s[3]++;
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    cov_pj8e38iik.s[4]++;
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_this));
    cov_pj8e38iik.s[5]++;
    _this.setFormStatus = _this.setFormStatus.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Card, [{
    key: "getCollapsed",
    value: function getCollapsed() {
      cov_pj8e38iik.f[1]++;

      var _ref = (cov_pj8e38iik.s[6]++, this.props),
          collapsible = _ref.collapsible,
          collapsed = _ref.collapsed;

      cov_pj8e38iik.s[7]++;

      if (!collapsible) {
        cov_pj8e38iik.b[0][0]++;
        cov_pj8e38iik.s[8]++;
        return undefined;
      } else {
        cov_pj8e38iik.b[0][1]++;
      }

      cov_pj8e38iik.s[9]++;
      return collapsed !== undefined ? (cov_pj8e38iik.b[1][0]++, collapsed) : (cov_pj8e38iik.b[1][1]++, this.state.collapsed);
    }
  }, {
    key: "setFormStatus",
    value: function setFormStatus(status) {
      cov_pj8e38iik.f[2]++;
      cov_pj8e38iik.s[10]++;

      if (status !== this.state.formStatus) {
        cov_pj8e38iik.b[2][0]++;
        cov_pj8e38iik.s[11]++;
        this.setState({
          formStatus: status
        });
      } else {
        cov_pj8e38iik.b[2][1]++;
      }
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_pj8e38iik.f[3]++;
      cov_pj8e38iik.s[12]++;
      this.element = el;

      var _ref2 = (cov_pj8e38iik.s[13]++, this.props),
          forwardedRef = _ref2.forwardedRef;

      cov_pj8e38iik.s[14]++;

      if (forwardedRef) {
        cov_pj8e38iik.b[3][0]++;
        cov_pj8e38iik.s[15]++;
        forwardedRef(el);
      } else {
        cov_pj8e38iik.b[3][1]++;
      }
    }
  }, {
    key: "handleCollapse",
    value: function handleCollapse() {
      cov_pj8e38iik.f[4]++;
      var collapsed = (cov_pj8e38iik.s[16]++, !this.getCollapsed());
      cov_pj8e38iik.s[17]++;

      if (this.props.onCollapse) {
        cov_pj8e38iik.b[4][0]++;
        cov_pj8e38iik.s[18]++;
        this.props.onCollapse(collapsed);
      } else {
        cov_pj8e38iik.b[4][1]++;
        cov_pj8e38iik.s[19]++;
        this.setState({
          collapsed: collapsed
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(target) {
      cov_pj8e38iik.f[5]++;
      var form = (cov_pj8e38iik.s[20]++, this.element.querySelector('form'));
      cov_pj8e38iik.s[21]++;

      if (form) {
        cov_pj8e38iik.b[5][0]++;
        cov_pj8e38iik.s[22]++;
        dispatchEvent(form, 'submit', target);
      } else {
        cov_pj8e38iik.b[5][1]++;
        cov_pj8e38iik.s[23]++;
        console.error(new Error('No form found.'));
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_pj8e38iik.f[6]++;

      var _ref3 = (cov_pj8e38iik.s[24]++, this.props),
          collapsible = _ref3.collapsible;

      var collapsed = (cov_pj8e38iik.s[25]++, this.getCollapsed());
      var shadow = (cov_pj8e38iik.s[26]++, this.props.shadow === true ? (cov_pj8e38iik.b[6][0]++, 'shadow') : (cov_pj8e38iik.b[6][1]++, this.props.shadow));
      var className = (cov_pj8e38iik.s[27]++, classnames(cardClass('_', shadow, (cov_pj8e38iik.b[7][0]++, collapsible) && (cov_pj8e38iik.b[7][1]++, 'collapsible'), (cov_pj8e38iik.b[8][0]++, collapsed) && (cov_pj8e38iik.b[8][1]++, 'collapsed'), (cov_pj8e38iik.b[9][0]++, isRTL()) && (cov_pj8e38iik.b[9][1]++, 'rtl')), this.props.className));
      var provierValue = (cov_pj8e38iik.s[28]++, {
        onCollapse: this.handleCollapse,
        collapsible: collapsible,
        collapsed: collapsed,
        formStatus: this.state.formStatus,
        onSubmit: this.handleSubmit,
        setFormStatus: this.setFormStatus
      });
      cov_pj8e38iik.s[29]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          ref: this.bindElement,
          style: this.props.style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 91,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Provider, {
          value: provierValue,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 92,
            columnNumber: 9
          }
        }, this.props.children))
      );
    }
  }]);

  return Card;
}(PureComponent);

Card.defaultProps = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  defaultCollapsed: true,
  collapsible: false
});
export default compose(moveable(".".concat(cardClass('header'), ", .").concat(modalClass('method-title'))), resizable)(Card);